import { useEffect, useRef, useState } from 'react';
import api from '../../lib/api';
import { Input } from '../ui/input';

// Iter 389 — compartido por Generar OC y OC Express. El Solicitante es obligatorio para grabar una OC.
export function SolicitanteAutocomplete({ value, onChange, required = true, testid = 'input-solicitante', className = '' }) {
  const [suggestions, setSuggestions] = useState([]);
  const [showSugg, setShowSugg] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const h = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setShowSugg(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const loadSolicitantes = async () => {
    if (loaded) return;
    try {
      const res = await api.get('/compras/solicitantes');
      setSuggestions(res.data.solicitantes || []);
      setLoaded(true);
    } catch { /* ignore */ }
  };

  const filtered = suggestions.filter((s) => !value || s.toLowerCase().includes(value.toLowerCase()));
  const vacio = required && !(value || '').trim();

  return (
    <div className={`relative ${className}`} ref={wrapRef}>
      <label className="block text-xs font-medium mb-1">Solicitante{required && <span className="text-red-600"> *</span>}</label>
      <Input placeholder="Nombre (escriba o seleccione)" value={value}
        onChange={(e) => { onChange(e.target.value); setShowSugg(true); }}
        onFocus={() => { loadSolicitantes(); setShowSugg(true); }}
        className={vacio ? 'border-red-400 bg-red-50/40' : ''}
        data-testid={testid} />
      {vacio && <p className="mt-0.5 text-[10px] text-red-600" data-testid={`${testid}-requerido`}>Obligatorio para grabar la OC</p>}
      {showSugg && filtered.length > 0 && (
        <div className="absolute z-50 w-full mt-0.5 bg-white border rounded-md shadow-lg max-h-40 overflow-y-auto">
          {filtered.map((s, i) => (
            <button type="button" key={`sol-${i}`} onClick={() => { onChange(s); setShowSugg(false); }}
              className="w-full text-left px-3 py-1.5 text-xs hover:bg-blue-50 border-b last:border-0">
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
